import type { ButtonHTMLAttributes, MouseEvent, ReactElement, Ref } from 'react';
import styles from './Button.module.css';

type Variant = 'primary' | 'secondary' | 'danger' | 'dangerOutline';

interface ButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'className'> {
  variant?: Variant;
  /**
   * Operação em andamento. O botão parece e se anuncia como desabilitado (`aria-disabled`) e
   * ignora cliques, mas CONTINUA focável: com `disabled` de verdade o navegador pode jogar o foco
   * para o <body> no meio da operação, e quem usa teclado perde o lugar.
   */
  busy?: boolean;
  ref?: Ref<HTMLButtonElement>;
}

/** Botão do painel de detalhes: alvo de toque de pelo menos 40px e as quatro aparências usadas aqui. */
export function Button({
  variant = 'secondary',
  busy = false,
  type = 'button',
  onClick,
  children,
  ...rest
}: ButtonProps): ReactElement {
  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    if (busy) {
      event.preventDefault(); // também impede o envio do formulário
      return;
    }
    onClick?.(event);
  };
  return (
    <button
      {...rest}
      type={type}
      className={`${styles.button} ${styles[variant]}`}
      aria-disabled={busy || undefined}
      aria-busy={busy || undefined}
      onClick={handleClick}
    >
      {children}
    </button>
  );
}
